import { render, staticRenderFns } from "./RentalObjectFeatures.vue?vue&type=template&id=2ce16cc2&scoped=true&"
import script from "./RentalObjectFeatures.vue?vue&type=script&lang=js&"
export * from "./RentalObjectFeatures.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectFeatures.vue?vue&type=style&index=0&id=2ce16cc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce16cc2",
  null
  
)

export default component.exports